import React from 'react';
import { Cloud, Server, Users, Settings, Headphones, BookOpen, MessageSquare } from 'lucide-react';

const Services: React.FC = () => {
  const services = [
    {
      icon: <Cloud />,
      title: "Plataformas LMS Administradas",
      description: "Plataformas educativas completamente configuradas y gestionadas (Moodle, Canvas, etc.). Hosting optimizado, administración técnica completa y soporte especializado.",
      features: [
        "Configuración y personalización",
        "Hosting optimizado y escalable",
        "Administración técnica completa",
        "Actualizaciones y seguridad",
        "Backups automáticos diarios",
        "Soporte técnico 24/7"
      ],
      link: "/plataformas-lms"
    },
    {
      icon: <MessageSquare />,
      title: "CRM y Canales Digitales",
      description: "Centraliza y gestiona todos tus canales de contacto (WhatsApp, Instagram, formularios web) desde un sistema CRM unificado con asistencia automatizada.",
      features: [
        "Integración WhatsApp e Instagram",
        "CRM centralizado para prospectos",
        "Asistencia automatizada con IA",
        "Derivación inteligente a ejecutivos",
        "Seguimiento comercial completo",
        "Mejora tiempos de respuesta"
      ],
      link: "/crm-canales-digitales"
    },
    {
      icon: <Server />,
      title: "Administración y Mantenimiento",
      description: "Gestión integral de tus plataformas educativas: actualizaciones, mantenimiento, optimización y monitoreo continuo por expertos certificados.",
      features: [
        "Actualizaciones de seguridad",
        "Monitoreo 24/7",
        "Optimización de rendimiento",
        "Gestión de plugins y extensiones"
      ],
      link: "/administracion-moodle"
    },
    {
      icon: <Users />,
      title: "Migración y Consolidación",
      description: "Migramos tus plataformas existentes sin pérdida de datos, conservando toda la estructura, contenido y consolidando sistemas dispersos.",
      features: [
        "Migración sin tiempo de inactividad",
        "Preservación de datos completa",
        "Pruebas exhaustivas previas",
        "Soporte durante la transición"
      ],
      link: "/migracion-consolidacion"
    },
    {
      icon: <Settings />,
      title: "Integraciones y Desarrollo",
      description: "Conectamos tus plataformas educativas con sistemas externos (ERP, CRM, pagos) y desarrollamos funcionalidades personalizadas según tus necesidades.",
      features: [
        "Integraciones API personalizadas",
        "Desarrollo de plugins y extensiones",
        "Temas corporativos únicos",
        "Sincronización con sistemas externos"
      ],
      link: "/integraciones-desarrollo"
    },
    {
      icon: <Headphones />,
      title: "Soporte Especializado",
      description: "Equipo de expertos certificados disponible para resolver cualquier incidencia técnica y optimizar el rendimiento de tus plataformas.",
      features: [
        "Soporte multicanal prioritario",
        "Respuesta en menos de 2 horas",
        "Expertos certificados",
        "Base de conocimientos exclusiva"
      ],
      link: "/soporte-especializado"
    },
    {
      icon: <BookOpen />,
      title: "Capacitación y Consultoría",
      description: "Formamos a tu equipo en el uso efectivo de las plataformas y proporcionamos consultoría estratégica para maximizar tu inversión digital.",
      features: [
        "Talleres presenciales y virtuales",
        "Materiales de formación incluidos",
        "Certificaciones oficiales disponibles",
        "Consultoría estratégica continua"
      ],
      link: "/capacitacion-consultoria"
    }
  ];

  return (
    <section id="servicios" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Nuestras Soluciones</h2>
          <p className="section-subtitle">
            Servicios digitales integrales para universidades, institutos profesionales, 
            centros de capacitación y programas de educación continua
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="service-feature">
                    {feature}
                  </li>
                ))}
              </ul>
              {service.link && (
                <div className="service-cta">
                  <a href={service.link} className="btn btn-primary">
                    Ver Más Detalles
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>¿Necesitas una solución personalizada?</h3>
            <p>Contáctanos para discutir tus requerimientos específicos y crear un plan adaptado a tu institución.</p>
            <a href="#contacto" className="btn btn-primary">Solicitar Consulta Gratuita</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;